
import { Form, FormField, useForm } from "@repo/ui/components/form";
import { useTranslation } from "react-i18next";
import { useDataDropdown } from "~/utils/home";
import { Button } from "@repo/ui/components/button";
import SelectDropdown from "~/components/select-dropdown";
import { useMemo } from "react";
import { Search } from "@repo/ui/components/icon";
import { useSearchParams } from 'react-router';

type FormSearchParams = {
  search?: string;
  areaRange?: string;
  categoryId?: string;
  priceRange?: string;
  provinceId?: string;
};

type FormSearchProductProps = {
  params?: FormSearchParams;
  page?: { pageNumber?: number; pageSize?: number };
};

function FormSearchProduct({ params, page }: FormSearchProductProps) {
  const { province, listArea, category, listPrice } = useDataDropdown();
  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTranslation("home");
  const form = useForm({
    defaultValues: params || {},
  });
  const onSubmit = (data: any) => {
    const current = Object.fromEntries(searchParams);
    const nextParams = {
      ...current,
      ...data,
      provinceId: data.provinceId === 'all' ? '' : data.provinceId,
      categoryId: data.categoryId === 'all' ? '' : data.categoryId,
      priceRange: data.priceRange === 'all' ? '' : data.priceRange,
      areaRange: data.areaRange === 'all' ? '' : data.areaRange,
      pageNumber: '1',
      pageSize: current.pageSize || String(page?.pageSize || 9),
    } as Record<string, string>;

    Object.keys(nextParams).forEach((key) => {
      if (nextParams[key] === '' || nextParams[key] === undefined) {
        delete nextParams[key];
      }
    });
    setSearchParams(nextParams);
  };
  const list_province = useMemo(() => {
    return [
      {
        label: t("search_box.find_form.filters.region_all"),
        value: "all",
      },
    ].concat(province);
  }, [province, t]);
  const list_category = useMemo(() => {
    return [
      {
        label: t("search_box.find_form.filters.real_estate_type_all"),
        value: "all",
      },
    ].concat(category);
  }, [category, t]);
  return (
    <Form {...form}>
      <form
        className="grid gap-5 py-5"
        id="post-form"
        onSubmit={form.handleSubmit(onSubmit)}
      >
        <div className="overflow-scroll">
          <div className="flex gap-5 min-w-[920px] bg-primary p-5 rounded-[20px]">
            <div className="grid flex-1 grid-cols-4 gap-5">
              <FormField
                name="provinceId"
                control={form.control}
                render={({ field }) => (
                  <SelectDropdown
                    isControlled
                    {...field}
                    defaultValue={field.value}
                    onValueChange={field.onChange}
                    items={list_province}
                    label={t("search_box.find_form.filters.region")}
                  />
                )}
              />

              <FormField
                name="categoryId"
                control={form.control}
                render={({ field }) => (
                  <SelectDropdown
                    isControlled
                    {...field}
                    defaultValue={field.value}
                    onValueChange={field.onChange}
                    items={list_category}
                    label={t("search_box.find_form.filters.real_estate_type")}
                  />
                )}
              />

              <FormField
                name="priceRange"
                control={form.control}
                render={({ field }) => (
                  <SelectDropdown
                    isControlled
                    {...field}
                    defaultValue={field.value}
                    onValueChange={field.onChange}
                    items={listPrice}
                    label={t("search_box.find_form.filters.price")}
                  />
                )}
              />
              <FormField
                name="areaRange"
                control={form.control}
                render={({ field }) => (
                  <SelectDropdown
                    isControlled
                    {...field}
                    defaultValue={field.value}
                    onValueChange={field.onChange}
                    items={listArea}
                    label={t("search_box.find_form.filters.area")}
                  />
                )}
              />
            </div>
            <div className="flex items-center pl-4 pr-2 bg-white border border-gray-400 rounded-xl">
              <FormField
                name="search"
                control={form.control}
                render={({ field }) => (
                  <input
                    {...field}
                    className="flex-1 h-12 outline-0"
                    placeholder={t(
                      "search_box.find_form.search_area_placeholder"
                    )}
                  />
                )}
              />

              <Button size={"icon"} type="submit">
                <Search />
              </Button>
            </div>
          </div>
        </div>
      </form>
    </Form>
  );
}
export default FormSearchProduct
